// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3Vd1N","title":"ClientInsurance_title__1NB9F","itemText":"ClientInsurance_itemText__2ZhJj"};